import React from "react";
import { qrAuthType } from "../../../../recoil/auth";
import CustomDelight, { delightCustomList } from "./customDelight";
import CustomKkhotel, { knockCustomList } from "./customKkhotel";

export const customUserIdList = [2347, 2363];

const CustomSection = (props: {
  auth: qrAuthType;
  navigateAdStore: any;
  adverClick: any;
}) => {
  const user_id = props.auth.user_id;
  if (customUserIdList.includes(user_id)) {
    if (user_id === 2347) {
      //delight
      return (
        <CustomDelight
          navigateAdStore={props.navigateAdStore}
          adverClick={props.adverClick}
        />
      );
    } else if (user_id === 2363) {
      //kkhotel
      return (
        <>
          <CustomKkhotel
            navigateAdStore={props.navigateAdStore}
            adverClick={props.adverClick}
          />
        </>
      );
    } else {
      return <></>;
    }
  } else {
    return <></>;
  }
};

export const getCustomListByUserId = (user_id: number) => {
  if (user_id === 2347) {
    return delightCustomList.length; //delight
  }
  if (user_id === 2363) {
    return knockCustomList.length;
  }
  return 0;
};

export default CustomSection;
